export enum LabelType {
  MetaStatus = 'meta-status',
  Language = 'lang',
  DeviceType = 'device',
  ScreenSize = 'screen',
  ClientType = 'client',
  Role = 'role',
  Category = 'category',
  Engine = 'engine',
  Custom = 'custom',
}
